let nextTimingId = 1;
let initialHeatmapTimingLabel: string | null = null;
let initialHeatmapTimingEnded = false;

function createTimingLabel(scope: string): string {
  const id = nextTimingId;
  nextTimingId += 1;
  return `${scope}:${Date.now()}-${id}`;
}

export function startClientTiming(scope: string): () => void {
  const label = createTimingLabel(scope);
  let ended = false;

  console.time(label);

  return () => {
    if (ended) {
      return;
    }

    ended = true;
    console.timeEnd(label);
  };
}

export async function timeClientAsync<T>(scope: string, operation: () => Promise<T>): Promise<T> {
  const endTiming = startClientTiming(scope);
  try {
    return await operation();
  } finally {
    endTiming();
  }
}

export function startInitialHeatmapTiming(): void {
  if (initialHeatmapTimingLabel != null) {
    return;
  }

  initialHeatmapTimingLabel = createTimingLabel('ui/initial-heatmap-visible');
  console.time(initialHeatmapTimingLabel);
}

export function endInitialHeatmapTiming(): void {
  if (initialHeatmapTimingLabel == null || initialHeatmapTimingEnded) {
    return;
  }

  initialHeatmapTimingEnded = true;
  console.timeEnd(initialHeatmapTimingLabel);
}
